import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const HomeWrapper = styled.main`
  background: #f7f8fa;
  color: #1f242b;
  overflow: hidden;
`;

export const HeroSection = styled.section`
  align-items: center;
  background:
    linear-gradient(90deg, rgba(31, 36, 43, 0.96), rgba(31, 36, 43, 0.88)),
    #1f242b;
  color: #ffffff;
  display: grid;
  gap: clamp(2rem, 5vw, 4.5rem);
  grid-template-columns: minmax(0, 1.02fr) minmax(320px, 0.98fr);
  margin: 0 auto;
  padding: clamp(3.5rem, 8vw, 6.75rem) max(1.25rem, calc((100vw - 1180px) / 2 + 1.25rem));

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    padding-top: 3rem;
  }
`;

export const HeroContent = styled.div`
  max-width: 640px;

  h1 {
    color: #ffffff;
    font-size: clamp(2.1rem, 6vw, 4.8rem);
    letter-spacing: 0;
    line-height: 0.98;
    margin: 0 0 1.25rem;
    overflow-wrap: break-word;
  }
`;

export const Eyebrow = styled.p`
  color: #60a5fa;
  font-size: 0.82rem;
  font-weight: 900;
  letter-spacing: 0;
  margin: 0 0 0.85rem;
  overflow-wrap: break-word;
  text-transform: uppercase;
`;

export const HeroLead = styled.p`
  color: #e2e8f0;
  font-size: clamp(1.05rem, 2vw, 1.28rem);
  line-height: 1.7;
  margin: 0 0 1.8rem;
`;

export const ButtonRow = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.85rem;
  min-width: 0;
`;

export const PrimaryButton = styled(Link)`
  align-items: center;
  background: #2563eb;
  border: 2px solid #2563eb;
  border-radius: 8px;
  color: #ffffff;
  display: inline-flex;
  font-weight: 900;
  justify-content: center;
  min-height: 48px;
  padding: 0.85rem 1.2rem;
  text-decoration: none;
  transition: background 160ms ease, border-color 160ms ease, transform 160ms ease;

  &:hover,
  &:focus-visible {
    background: #1d4ed8;
    border-color: #1d4ed8;
    transform: translateY(-1px);
  }

  @media (max-width: 520px) {
    width: 100%;
  }
`;

export const SecondaryButton = styled.a`
  align-items: center;
  background: transparent;
  border: 2px solid currentColor;
  border-radius: 8px;
  color: inherit;
  display: inline-flex;
  font-weight: 900;
  justify-content: center;
  min-height: 48px;
  padding: 0.85rem 1.2rem;
  text-decoration: none;
  transition: background 160ms ease, color 160ms ease, transform 160ms ease;

  &:hover,
  &:focus-visible {
    background: #ffffff;
    color: #1f242b;
    transform: translateY(-1px);
  }

  @media (max-width: 520px) {
    width: 100%;
  }
`;

export const TrustList = styled.ul`
  display: grid;
  gap: 0.65rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  list-style: none;
  margin: 2rem 0 0;
  padding: 0;

  li {
    align-items: center;
    color: #edf2f7;
    display: flex;
    font-weight: 800;
    gap: 0.55rem;
  }

  li::before {
    background: #2563eb;
    border-radius: 999px;
    content: '';
    display: inline-block;
    flex: 0 0 auto;
    height: 0.52rem;
    width: 0.52rem;
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const HeroMedia = styled.div`
  position: relative;

  img {
    aspect-ratio: 4 / 3;
    border-radius: 8px;
    box-shadow: 0 28px 70px rgba(0, 0, 0, 0.32);
    display: block;
    height: 100%;
    max-height: 560px;
    object-fit: cover;
    width: 100%;
  }
`;

export const HeroBadge = styled.div`
  background: #ffffff;
  border-radius: 8px;
  bottom: 1rem;
  box-shadow: 0 18px 38px rgba(17, 24, 39, 0.22);
  color: #1f242b;
  display: grid;
  gap: 0.25rem;
  left: 1rem;
  max-width: 285px;
  padding: 1rem;
  position: absolute;

  strong {
    font-size: 1rem;
  }

  span {
    color: #667085;
    line-height: 1.5;
  }

  @media (max-width: 520px) {
    left: 0.75rem;
    right: 0.75rem;
  }
`;

export const Section = styled.section`
  margin: 0 auto;
  max-width: 1180px;
  padding: clamp(3.25rem, 7vw, 5.75rem) 1.25rem;
`;

export const SectionHeader = styled.div`
  max-width: 760px;
  margin-bottom: 2rem;

  h2 {
    color: #1f242b;
    font-size: clamp(1.85rem, 4vw, 3rem);
    letter-spacing: 0;
    line-height: 1.08;
    margin: 0 0 0.85rem;
    overflow-wrap: break-word;
  }

  p {
    color: #586271;
    font-size: 1.05rem;
    line-height: 1.7;
    margin: 0;
  }
`;

export const ServiceGrid = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(3, minmax(0, 1fr));

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 680px) {
    grid-template-columns: 1fr;
  }
`;

export const ServiceCard = styled.article`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 18px 38px rgba(17, 24, 39, 0.07);
  display: grid;
  overflow: hidden;

  h3 {
    color: #1f242b;
    font-size: 1.2rem;
    line-height: 1.25;
    margin: 0 0 0.55rem;
  }

  p {
    color: #586271;
    line-height: 1.65;
    margin: 0 0 1rem;
  }

  img {
    display: block;
    width: 100%;
    height: 210px;
    object-fit: cover;
  }

  div {
    padding: 1.2rem;
  }

  a {
    color: #1d4ed8;
    font-weight: 900;
    text-decoration: none;
  }

  a:hover,
  a:focus-visible {
    text-decoration: underline;
    text-underline-offset: 0.22rem;
  }
`;

export const WhyGrid = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(3, minmax(0, 1fr));

  @media (max-width: 820px) {
    grid-template-columns: 1fr;
  }
`;

export const WhyCard = styled.article`
  background: #ffffff;
  border-left: 5px solid #2563eb;
  border-radius: 8px;
  box-shadow: 0 18px 38px rgba(17, 24, 39, 0.06);
  padding: 1.4rem;

  h3 {
    color: #1f242b;
    margin: 0 0 0.6rem;
  }

  p {
    color: #586271;
    line-height: 1.7;
    margin: 0;
  }
`;

export const GalleryGrid = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(4, minmax(0, 1fr));

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const GalleryCard = styled.article`
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 18px 38px rgba(17, 24, 39, 0.07);
  color: #1f242b;
  display: grid;
  overflow: hidden;
  text-decoration: none;

  span {
    font-weight: 900;
    padding: 0.95rem 1rem;
  }
`;

export const GalleryImage = styled.img`
  aspect-ratio: 1 / 0.72;
  display: block;
  height: 100%;
  object-fit: cover;
  width: 100%;
`;

export const CTASection = styled.section`
  background: #1f242b;
  color: #ffffff;
  padding: clamp(3rem, 6vw, 5rem) 1.25rem;
`;

export const CTAContent = styled.div`
  margin: 0 auto;
  max-width: 860px;
  text-align: center;

  h2 {
    color: #ffffff;
    font-size: clamp(2rem, 4vw, 3.2rem);
    line-height: 1.08;
    margin: 0 0 1rem;
  }

  p {
    color: #e2e8f0;
    font-size: 1.08rem;
    line-height: 1.7;
    margin: 0 auto 1.5rem;
    max-width: 680px;
  }

  ${ButtonRow} {
    justify-content: center;
  }
`;
